/*
----- Modals ----- 
- This is the " popup / modal" logic, examples of use:
  - Confirmation prompts
  - Iframe modals ( opayo payment frame )
  - Various Editor(s) for vm admin.
  - To alert a user they have changes on a form before cancelling.
*/


import { component as axisVideoPlayer } from './axis-video-player';

// Modal instance for storing configurations and states.
var instances = {};
// Modal queue for handling modals that need to wait for the current modal to close.
var modalQueue = [];

/*
  Queue behavior options:
  - 'immediate': Opens on top of current modals.
  - 'queued': Waits until all current modal are closed before opening
  - 'background': Opens behind the current modal without disrupting user focus
*/
const queueBehaviours = {
    'immediate': 'immediate',
    'queued': 'queued',
    'background': 'background'
};

// Add a modal to the queue.
function queueModal(context, config = {}, behavior = queueBehaviours['queued']) {
    
    // Get the modal type.
    const type = context.attr(expressSelectors()['modals']['modal-context']);

    const queueEntry = {
        id: 'queue-' + generateId(),
        type: type,
        context: context,
        config: config,
        behavior: behavior,
        timestamp: Date.now()
    };

    modalQueue.push(queueEntry);

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, "Modals: Modal queued", { id: queueEntry['id'], behavior: behavior });
    }

    return queueEntry;
}

// Get the current queue.
function getQueue() {
    return modalQueue;
}

/*
    Clear the modal queue.
    - id => Optional specific queue entry id to remove
*/
function clearQueue(id) {
    if (id) {
        const index = modalQueue.findIndex(entry => entry['id'] === id);
        if (index > -1) {
            modalQueue.splice(index, 1);
            return true;
        }
        return false;
    }

    modalQueue = [];
    return true;
}

// Process the modal queue - opens the next queued modal if no modals are active.
function processQueue() {
    // Get active modals.
    let activeModals = getActiveModals();

    // If there are still active modals, don't process the queue.
    if (activeModals.length > 0) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "Modals: Queue not processed - active modals exist", { count: activeModals.length });
        }
        return false;
    }

    // If queue is empty, nothing to do.
    if (modalQueue.length === 0) {
        return false;
    }

    // Get the next queued modal (FIFO).
    const nextModal = modalQueue.shift();

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, "Modals: Processing queued modal", { id: nextModal['id'] });
    }

    // Open the modal.
    modalOpen(nextModal['context'], nextModal['config']);

    return true;
}

function getInstanceId(modal) {
    return modal.attr(expressSelectors()['modals']['modal-id']);
}


function setModalTriggerButtonContext(id, value) {
    return instances[id]['trigger-button'] = value;
}
function getModalTriggerButtonContext(id) {
    return (instances[id].hasOwnProperty('trigger-button') ? instances[id]['trigger-button'] : undefined);
}
function setModalButtonForm(id, value) {
    return instances[id]['form'] = value;
}
function getModalButtonForm(id) {
    return instances[id]['form'];
}
function setIncludeFormData(id, value) {
    return instances[id]['include-form-data'] = value;
}
function getIncludeFormData(id) {
    return instances[id]['include-form-data'];
}


function initialiseAll() {
    $('[' + expressSelectors()['modals']['modal-context'] + ']').each(function() {
        // Get context.
        let context = $(this);
        // Initialise the actual modal itself.
        let init = initialise(context);
    });
    // If there is modal then initialise listeners.
    if ($('[' + expressSelectors()['modals']['modal-context'] + ']').length) {
        let listeners = initialiseExpressModalListeners();
    }
}

function initialise(context) {
    if (!context.hasClass('modal-container')) {
        context.addClass('modal-container');
    }
    // If modals are within main container move out of container other blur effect will be over the modal.
    context.each(function() {
        // Grab context.
        let context = $(this);
        // Model type.
        let type = context.attr('data-modal');
        // Make sure there are no other modals of this type.
        if (type) {
            // If there is modal inside of the main content.
            if ($('body').find('main [data-modal=' + type + ']').length > 0) {
                // Does that modal exist outside of the main content?
                if ($('body').find('> [data-modal=' + type + ']').length > 0) {
                    // If it does then remove it.
                    $('body').find('> [data-modal=' + type + ']').remove();
                }
            }
        } 
        
        // If inside of main.
        if (context.parents('main').length > 0) {
            // Move outside of main.
            context.appendTo('body');
        }
    });

    let id = context.attr(expressSelectors()['modals']['modal-id']);
    // If no id the generate one.
    if (!id) {
        id = "modal-" + generateId();
        // Update DOM.
        context.attr(expressSelectors()['modals']['modal-id'], id);
    }
    // Add instance to obj.
    if (instances.hasOwnProperty(id)) {
        // Due to ajax post was this modal previously active.
        let isActive = instances[id]['is-active'];
        if (isActive) {
            // Close original modal ( i.e get rid of the background + scroll lock).
            // modalClose(context);
            // Re-open it, do it this way then re-attaches the close listeners.
            modalOpen(context);
        }
    } else {
        instances[id] = {};
    }
    return context;
}

function initialiseExpressModalListeners() {
    // Iframe Modals.
    $('body').on('click', 'a[data-modal-iframe], button[data-modal-iframe]', function(event) {
        // Prevent default behavour.
        event.preventDefault();
        // Store context.
        let context = $(this);
        // Button disabled check.
        let disabledCheck = triggerDisabledCheck(context);
        if (disabledCheck) {
            return true;
        }
        // If this button has a confirm modal attached make sure the confimration has been confirmed before proceeding.
        if (context.attr(expressSelectors()['modals']['confirm'])) {
            // If not confirmed then back out of function.
            let isConfirmed = context.attr(expressSelectors()['modals']['confirmed']);
            if (isConfirmed == undefined) {
                return false;  
            }
        }
        // Capture form context.
        let form = context.parents('form');
        // Check if form must be valid before triggering modal, Enabled by default if context is in an abide form.
        let formValidRequired = context.data('form-validation-required');
        // Check if context is within an abide form.
        let isAbideForm = form.attr('data-abide');
        if (isAbideForm) {
            formValidRequired = true;
        }
        // Modal type.
        let type = context.data('modal-iframe');
        if (type == "") {
            AXISDebug.output(3,"Modals: You must provide a modal type");
            return false;
        }
        // Get modal markup.
        let markup = $('.modal-container[data-modal=' + type + ']');
        // Get src.
        let src = markup.attr(expressSelectors()['modals']['iframe-src']);
        if (!src) {
            AXISDebug.output(3,"Modals: No iframe src specified.");
            return false;
        }

        // If this is a button get src from form element.
        if (form) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Modals: Button is inside of a form defaulting to serialising the form and adding it to url");
            }
            // Get form data.
            let data = form.serialize();
            // Check if src has query string.
            let hasQueryString = queryStringParamsExists(src);
            // Add data from form to source.
            if (data.length) {
                src = src + (hasQueryString > 0 ? "&" + data : "?" + data);
            }
        }

        if (formValidRequired) {
            // Run form validation.
            form.foundation('validateForm');
            if (form.hasClass('is-invalid')) {
                return false;
            }
        }

        // Inject container.
        let injectContainer = markup.find('[inject-container]');
        if (injectContainer) {
            // Being consistent with ajax modals.
            injectContainer.html(`<iframe src="${src}"></iframe>`)
        } else {
            // Old way of doing this.
            // Append markup.
            markup.find('iframe').attr('src', src);
        }
        // Open modal.
        modalOpen(markup);
        // Prevent link from posting to server.
        return false;
    });
    // Confirm modals ( alert, warning & confirmation ).
    $('body').on('click', 'a[' + expressSelectors()['modals']['confirm'] + '], button[' + expressSelectors()['modals']['confirm'] + ']', function(event) {
        // Store context.
        let context = $(this);
        // If is a unsaved changed prompt?
        let unsavedChanges = context.data('unsaved-changes');
        if (unsavedChanges) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Modals: Running unsaved changes check against form:" + unsavedChanges);
            }
            let currentState = $('#' + unsavedChanges).serialize();
            let originalState = formOriginalState(unsavedChanges);
            if (originalState == currentState) {
                
                return true;
            } else if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Modals: Triggering unsaved changes modal due to the form being changed from its original state.", {"original-state": originalState, "current-state": currentState});
            }
        }
        // Prevent default behavour.
        event.preventDefault();
        // Button disabled check.
        let disabledCheck = triggerDisabledCheck(context);
        if (disabledCheck) {
            return true;
        }
        // Check whether modal has already been confirmed.
        let isConfirmed = context.attr(expressSelectors()['modals']['confirmed']);
        if (isConfirmed != undefined) {
            return false;
        }
    
        // Button id.
        let buttonId = context.attr('id');
        // Fallback.
        if (!buttonId) {
            buttonId = context.attr('name');
        }
        // href.
        let href = context.attr('href');
        // ajax call back.
        let ajax = context.data('ajax');   
        // Modal type.
        let type = context.attr(expressSelectors()['modals']['confirm']);
        // Submission button.
        let submission = context.attr('type');
        // Find out whether to trigger the modal or not, this is essentially validation.
        let trigger = triggerConditions(context);

        if (type == "") {
            AXISDebug.output(3,"Modals: You must provide a modal type");
        }
        // Get markup / modal context.
        let markup = $('.modal-container[data-modal=' + type + ']');     

        if (trigger) {
            // Append markup.
            markup.find('.prompt-proceed-button').attr('href', href).attr('data-ajax', ajax).attr('id', 'prompt-' + buttonId);
            // Buttons contexts ( i.e. accept or close )
            let buttons = new Object();
            // If you need the user's interaction before confirming.
            if (submission) {
                const config = {
                    context: context
                }
                // Register listener(s).
                buttons = modalConfirmListeners(markup, config);
            }

            let openConfig = new Object();
            if (buttons.hasOwnProperty('accept-button')) {
                openConfig['focus-element'] = buttons['accept-button'];
            } else if (buttons.hasOwnProperty('close-button')) {
                openConfig['focus-element'] = buttons['close-button'];
            }
            // Open modal.
            modalOpen(markup, openConfig);
            // Prevent link from posting to server.
            return false;
        } else {
            modalConfirm(context, markup);
            // If the initiator was a button[type='submit'] then carry on with the submission. 
            if (submission == "submit") {
                context.parents('form').trigger('submit');
            }
        }
    });
     // Form modals 
     $('body').on('click', 'a[data-modal-form], button[data-modal-form]', function(event) {
        // Prevent default behavour.
        event.preventDefault();
        // Store context.
        let context = $(this);
        // Button disabled check.
        let disabledCheck = triggerDisabledCheck(context);
        if (disabledCheck) {
            return true;
        }
        // Href / ajax gets used for the form action / data-ajax.
        // href.
        let href = context.attr('href');
        // ajax call back.
        let ajax = context.data('ajax');  
        // Modal type.
        let type = context.data('modal-form'); 
        // Make sure we have the type otherwise we cannot match the button to the modal.
        if (type == "") {
            AXISDebug.output(3,"Modals: You must provide a modal type");
            return false;
        } 
        // Get markup.
        let markup = $('.modal-container[data-modal=' + type + ']'); 
        // Find the modal form.
        let form = markup.find('form');
        // If form then replace post location.
        if (form.length > 0) {
            // Set action url if defined.
            if (href) {
                form.attr('action', href);
            }
            // Set ajax url if defined.
            if (ajax) {
                form.attr('data-ajax', ajax);
            }
        }
        
        if (markup.length > 0) {
            // Open modal.
            modalOpen(markup);
        } else {
            AXISDebug.output(3,"Modals: Could not find form modal", type);
            return false;
        }
        
    });


    $('body').on('keydown', '[' + expressSelectors()['modals']['input'] + ']', function(event) {
        // Get context.
        let context = $(this);
        // Get button Id.
        let id = context.attr(expressSelectors()['modals']['input']);
        // If enter key.
        if (event.key == "Enter") {
            // Prevent form from submitting as we just want to do a lookup callback.
            event.preventDefault();
            // trigger a callback.
            $('#' + id).trigger('click');
            return false;
        }
    });

    // Dynamic content.
    $('body').on('click', 'a[data-modal-ajax], button[data-modal-ajax]', function(event) {
        // Prevent default behavour.
        event.preventDefault();
        // Store context.
        let context = $(this);
        // Modal type.
        let type = context.data('modal-ajax'); 
        // Make sure we have the type otherwise we cannot match the button to the modal.
        if (type == "") {
            AXISDebug.output(3,"Modals: You must provide a modal type");
            return false;
        } 
        // Get markup.
        let modal = $('.modal-container[data-modal=' + type + ']');
        if (modal.length == 0) {
            AXISDebug.output(3,"Modals: Could not find markup for the ajax modal");
            return false;
        }
        // Is there an input assigned to this modal?
        let input = $('[' + expressSelectors()['modals']['input'] + '=' + context.attr('id') + ']');
        if (input.length) {
            // Is validation enabled?
            let abideEnabled = AXISInputs.isAbideEnabled(context);
            // Is it valid?
            let isValid = (abideEnabled ? AXISInputs.validateInput(input, true) : null);
            let validationOutput = (abideEnabled ? AXISInputs.validationOutput2(input, isValid) : null);
            if (isValid == false) {
                return false;
            }
        }
        // Check if form must be valid before triggering modal, Enabled by default if context is in an abide form.
        let formValidRequired = modal.data('form-validation-required');
        // Button disabled check.
        let disabledCheck = triggerDisabledCheck(context);
        if (disabledCheck) {
            return true;
        }
        // If this button has a confirm modal attached make sure the confimration has been confirmed before proceeding.
        if (context.attr(expressSelectors()['modals']['confirm'])) {
            // If not confirmed then back out of function.
            let isConfirmed = context.attr(expressSelectors()['modals']['confirmed']);
            if (isConfirmed == undefined) {
                return false;  
            }
        }
        // Capture form context.
        let form = context.parents('form');
        // Check if context is within an abide form.
        let isAbideForm = form.attr('data-abide');
        if (isAbideForm && formValidRequired == undefined) {
            formValidRequired = true;
        }

        if (form) {
            // IF formValidRequired not false and not undefined then run validation.
            if (formValidRequired) {
                // Run form validation.
                form.foundation('validateForm');
                if (form.hasClass('is-invalid')) {
                    return false;
                }
            }
        }


        // Get modal instance id.
        let instanceId = getInstanceId(modal);
        // If button is inside of a form then add context to instance.
        setModalButtonForm(instanceId, form);
        setIncludeFormData(instanceId, (modal.attr(expressSelectors()['modals']['include-form']) != undefined ? true : false));
        setModalTriggerButtonContext(instanceId, context);
        // Fill out custom value.
        let customValue = AXISAjax.getCustomNameValuePair(context);

        // Add spinner to where the content is going to be updated.
        // Suppressing this for now and merged this into AJAXBlock mechanism to try and detect whether it needs to traverse up or down the DOM to located the callback container.
        //modalAjaxContainer(modal).append(AXISAjax.getContentBlockSpinner());
        // Make sure modal content is cleared before opening just incase you're re-using the modal.
        modal.find('[inject-container]').empty();
        // Open modal.
        modalOpen(modal);
        // Get content.
        modalAjaxCallback(modal, {'custom-name-pair': customValue}, instanceId).then(() => {
            // Open modal.
            //modalOpen(modal);
        }).catch((error) => {
            AXISDebug.output(3,error);
            modalClose(modal);
        });
    });

    // Static content modal, e.g. content does doesn't fit within the AJAX or Form modal context.
    $('body').on('click', 'a[' + expressSelectors()['modals']['static'] + '], button[' + expressSelectors()['modals']['static'] + ']', function(event) {
        event.preventDefault();
        // Store context.
        const context = $(this);
        const disabledCheck = triggerDisabledCheck(context);
        if (disabledCheck) {
            return true;
        }
        // Get modal type.
        const type = context.attr(expressSelectors()['modals']['static']);
        if (!type || type == "") {
            AXISDebug.output(3,"Modals: You must provide a modal type");
            return false;
        }
        // Get modal context.
        const modalContext = $('.modal-container[' + expressSelectors()['modals']['modal-context'] + '=' + type + ']');
        if (!modalContext.length) {
            AXISDebug.output(3,"Modals: Could not find modal context for static modal");
            return false;
        }
        // Open modal.
        modalOpen(modalContext);
    });

    $('body').on('click', 'a[data-modal-video], button[data-modal-video]', function(event) {
        // Prevent default behavour.
        event.preventDefault();
        // Store context.
        let context = $(this);
        // Button disabled check.
        let disabledCheck = triggerDisabledCheck(context);
        if (disabledCheck) {
            return true;
        }
        // Modal type.
        let type = context.attr('data-modal-video'); 
        // Make sure we have the type otherwise we cannot match the button to the modal.
        if (type == "") {
            AXISDebug.output(3,"Modals: You must provide a modal type");
            return false;
        } 
        // Get markup.
        let modal = $('.modal-container[data-modal=' + type + ']');
        if (modal.length == 0) {
            AXISDebug.output(3,"Modals: Could not find markup for the ajax modal");
            return false;
        }
        // Find heading.
        let headingText = context.find('[data-modal-header-text]');
        if (headingText) {
            headingText = headingText.text();
            // Find header.
            let modalHeader = modal.find('[data-modal-header-text]');
            if (modalHeader.length) {
                // Update DOM.
                modalHeader.text(headingText);
            }
        }
        // Intro copy.
        let introCopy = context.find('[data-modal-intro-copy]');
        // Find intro copy.
        let modalIntroCopy = modal.find('[data-modal-intro-copy]');
        if (introCopy.length) {
            introCopy = $(introCopy.html());
            
            if (modalIntroCopy.length) {
                // Sanitise markup, remove any inline styling that could get in the way of the modal layout ( i.e read more height ).
                introCopy = introCopy.find('*').removeAttr('style');
                //introCopy.find('*').removeAttr('style');
                // Update DOM.
                modalIntroCopy.html(introCopy);
                // Check if container previously disabled.
                if (modalIntroCopy.hasClass('disabled-no-content')) {
                    modalIntroCopy.removeClass('disabled-no-content');
                }
            }
        } else if (!introCopy.length && !modalIntroCopy.hasClass('disabled-no-content')) {
            // Suppress container.
            modalIntroCopy.addClass('disabled-no-content');
        }
        // Find inject container.
        let injectContainer = modal.find('[' + expressSelectors()['modals']['inject-container'] + ']');
        if (!injectContainer.length) {
            console.error("Modals; Could not find inject container for video modal", modal);
            return false;
        }
        // Get Url.
        let url = context.attr(expressSelectors()['axis-video-player']['url']);
        // Is there a container for the video?
        let videoContainer = injectContainer.find('[' + expressSelectors()['axis-video-player']['initialise'] + ']');
        // If is the same url.
        let loadedVideoUrl = videoContainer.attr(expressSelectors()['axis-video-player']['url']);
        // Used to interact with the player.
        let player;
        // Detect if we need to resume playback or load a different video.
        let isResuming = false;
        if (loadedVideoUrl == url) { 
            player = axisVideoPlayer.startPlayer(videoContainer);
            isResuming = true;
        } else {
            if (videoContainer.length) {
                axisVideoPlayer.destroy(videoContainer);
                injectContainer.empty();
            }
            injectContainer.append(`<div ${expressSelectors()['axis-video-player']['initialise']}></div>`);
            videoContainer =  injectContainer.find('[' + expressSelectors()['axis-video-player']['initialise'] + ']');

            videoContainer.attr(expressSelectors()['axis-video-player']['url'], url);
            // Get player.
            player = axisVideoPlayer.initialise(videoContainer);
        }  
        let open = modalOpen(modal);
        open.then((m) => {
            // If this is a fresh player.
            if (!isResuming) {
                // Automatically start the video.
                player.then((api) => {
                    // Re-establish context as the DOM would have changed by initialisation.
                    videoContainer =  injectContainer.find('[' + expressSelectors()['axis-video-player']['initialise'] + ']');
                    // Start player.
                    axisVideoPlayer.startPlayer(videoContainer);                 
                });
            }
        });
    });

    // Injected content i.e forms that need a modal for form inputs.
    $('body').on('click', 'a[data-modal-inject], button[data-modal-inject]', function(event) {
        // Prevent default behavour.
        event.preventDefault();
        // Store context.
        let context = $(this);
        // Button disabled check.
        let disabledCheck = triggerDisabledCheck(context);
        if (disabledCheck) {
            return true;
        }
        // Modal type.
        let type = context.data('modal-inject'); 
        // Make sure we have the type otherwise we cannot match the button to the modal.
        if (type == "") {
            AXISDebug.output(3,"Modals: You must provide a modal type");
            return false;
        } 
         // Get markup.
         let modal = $('.modal-container[data-modal=' + type + ']');
         if (modal.length == 0) {
             AXISDebug.output(3,"Modals: Could not find markup for the ajax modal");
             return false;
         }
        // Find content container with items we're going to clone.
        let originalContentContainer = $('#' + modal.attr(expressSelectors()['modals']['inject-content']));
        // Is the original content in a form? 
        let isForm = originalContentContainer.parents('form');
        // Find the actual content.
        let content = originalContentContainer.children();
        // Find where we're going to inject the content.
        let injectContainer = modal.find('[inject-container]');
        // Inject cloned content, modifying to not clone events as this causes validation to pre-maturely run.
        injectContainer.html(content.clone());
        // Find any form on input inside of injected container.
        let injectedInputs = injectContainer.find('input, select, textarea, label');
        // Add Suffix after every input id / name.
        injectedInputs.each(function(key, value) {
            // Grab Context.
            value = $(value);
            // Add suffix to every input.
            if (value.is('input, select, textarea')) {
                // Input Id.
                value.attr('id', value.attr('id') + "-modal");
                // Input Name.
                value.attr('name', value.attr('name') + "-modal");
            }
            // Suffix their labels.
            if (value.is('label')) {
                // Label for attribute.
                value.attr('for', value.attr('for') + "-modal");
            }
        });
        // Open modal.
        modalOpen(modal);
        // Find proceed button,
        let proceedButton = modal.find('.prompt-proceed-button');
        // Initialise client search if there is one.
        let clientSearchElement = modal.find('[' + expressSelectors()['client-search']['initialise'] + ']')
        if (clientSearchElement.length > 0) {
            let init = clientSearch.initialise(clientSearchElement);
        }
        // If proceed button exists then clone all content inside of the inject container and insert it into the original content container.
        if (proceedButton) {
            proceedButton.on('click', function() {
                // Remove suffix's that prevented id's & name's on input from clashing.
                injectedInputs.each(function(index, element) {
                    // value = $(value);
                    let injectedInput = $(element);
                    if (injectedInput.is('input, select, textarea')) {
                        // Name on injected input.
                        let name = injectedInput.attr('name');
                        name = name.replace("-modal", "");
                        // Value on injected input.
                        let value = injectedInput.val();
                        // Find original input.
                        const originalInput = $('[name="' + name + '"]');
                        // Check if in group.
                        const groupId = originalInput.attr(expressSelectors()['forms']['group-id']);
                        // Set value.
                        if (injectedInput.is('input[type="checkbox"]')) {
                            // HTML spec will always default the value to on.... so need to check the .prop.
                            value = injectedInput.prop('checked');
                            // Get the original value as this input may not need updating.
                            const originalValue = originalInput.prop('checked');
                            // Run check, as we don't want to prematurely run DOM changes if not needed as this will cause performance issues with validation.
                            if (originalValue != value) {
                                originalInput.prop('checked', value);
                                if (groupId) {
                                    originalInput.trigger('group-child-change');
                                }
                            }
                        } else {
                            const originalValue = originalInput.val();
                            if (originalValue != value) {
                                originalInput.val(value);
                                if (groupId) {
                                    originalInput.trigger('group-child-change');
                                }
                            }
                        }
                    }
                });
                // Remove click listener.
                proceedButton.off('click');
                // Close Modal.
                modalClose(modal);
                //originalContentContainer.find('input, select, textarea').trigger('change');
                // If the original content position is within a form the trigger its validation.
                // Suppressing validaiton as there is too much context required to accurately trigger this here, instead re-validation should be triggered lower down in axis-inputs.js otherwise you will get into timing issues with conditional containers closing.
                // if (isForm) {
                    //AXISInputs.validateForm(originalContentContainer.parents('form'));
                // }
            });
        }
    });

    // Scanner modal ( i.e barcode scanning )
    // Dynamic content.
    $('body').on('click', 'a[data-modal-scanner], button[data-modal-scanner]', function(event) {
        // Prevent default behavour.
        event.preventDefault();
        // Store context.
        let context = $(this);
        // Modal type.
        let type = context.data('modal-scanner'); 
        // Make sure we have the type otherwise we cannot match the button to the modal.
        if (type == "") {
            AXISDebug.output(3,"Modals: You must provide a modal type");
            return false;
        } 
        if (context.hasClass('disabled')) {
            AXISInputs.invalidReason(context);
            return false;
        }
        // Get markup.
        let modal = $('.modal-container[data-modal=' + type + ']');
        if (modal.length == 0) {
            AXISDebug.output(3,"Modals: Could not find markup for the ajax modal");
            return false;
        }
        // Find barcode scanner.
        let scanner = $('[' + expressSelectors()['axis-barcode-scanner']['initialise'] + ']');
        // Start scanner.
        axisBarcodeScanner.startScanning(scanner);
        // Open modal.
        modalOpen(modal);
        // On modal close disable scanner.
        modal.on("modal-closed", function(event) {
            // Stop scanning.
            axisBarcodeScanner.stopScanning(scanner);
            // Remove listener.
            modal.off('modal-closed');
        });
    });


    let onLoadModal = $('.modal-container[data-onload]');

    if (onLoadModal.length > 0) {
        onLoadModal.each(function() {
            let context = $(this);
            if (AXISDebug.level() > 0) {
                AXISDebug.output(1, "Modals: A on-load exists initialising.");
            }
            let type = context.data('modal');
            // Should the modal wait for an async callback response till opened.
            let async = (context.data('async') === 'true');
            // Check if this is a pwa modal.
            if (type == "app") {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Modals: PWA Prompting to install");
                }
                
                let initialise = AXISPWA.initialise(context);

                if (initialise == undefined) {
                    AXISDebug.output(3, "Modals: PWA failed to return promise on initialisation.");
                    return false;
                }

                initialise.then((response) => {
                    if (response['has-prompted']) {
                        if (AXISDebug.level() >= 3) {
                            AXISDebug.output(1, "Modals: PWA has already been prompted for it was " + response['has-prompted'] + ", exiting initialisation");
                        }
                        return false;
                    }

                    context.trigger('modal-async-complete');

                    let markup = $('.modal-container[data-modal=' + type + ']');
                    let proceedButton = markup.find('.prompt-proceed-button');
                    let cancelButton = markup.find('.prompt-cancel-button');
                    proceedButton.on('click', function(event) {
                        AXISPWA.install(context);
                        // Close modal.
                        modalClose();
                    });
                    cancelButton.on('click', function(event) {
                        event.preventDefault();
                        AXISPWA.decline(context);
                        
                    });
                }).catch((error) => {
                    AXISDebug.output(3, "PWA: Error: " , error);
                });
            }

            // If ajax modal.
            let ajax = context.data('ajax');

            if (ajax) {
                // Make sure the modal doesn't trigger till the callback is fullfilled.
                async = true;
                // Fill out custom value.
                let customValue = AXISAjax.getCustomNameValuePair(context);
                // Get instance id.
                let instanceId = getInstanceId(context);
                // Get content.
                modalAjaxCallback(context, {'custom-name-pair': customValue}, instanceId).then(() => {
                    // Fire event.
                    context.trigger('modal-async-complete');
                }).catch((error) => {
                    AXISDebug.output(3,error);
                });
            }

            if (async) {
                context.on('modal-async-complete', () => {
                    // Open Modal.
                    modalOpen(context);
                });
            } else {
                // If not waiting for an async callback then just open the modal.
                modalOpen(context);
            }
            
        });
    }
    // VM Admin editor.
    $('[data-modal=editor]').on('trigger-open', function(event) {
        // Modal context.
        let modal = $(this);
        // Open modal.
        let open = modalOpen(modal);
    });
}

function triggerDisabledCheck(context) {
    // Check if button is disabled.
    let isDisabled = context.hasClass('disabled');
    if (isDisabled) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Modals: Button has been disabled cancelling modal trigger");
        }
        return true;
    }
    // Check if this is a button and whether it is a submit button.
    let isButton = context.is('button[type=submit]');
    // Check whether form is valid.
    let formValid = !context.parents('form').hasClass('is-invalid');
    // If this is a button & type = submit + the form is invalid then cancel modal trigger.
    if (isButton && !formValid) {
        return true;
    }

}

function modalAjaxContainer(modal) {
    // Find the container that gets used to inject content into.
    let container = modal.find('[inject-container]');
    if (container.length == 0) {
        AXISDebug.output(3,"Modals: Could not find container to inject content into.");
        return false;
    }
    return container;
}

// In the absance of instance tracking a config object is passed in.
function modalConfirmListeners(modal, config = new Object()) {
    // Get context i.e initialisation varable.
    const context = (config.hasOwnProperty('context') ? config['context'] : undefined);
    if (!context) {
        AXISDebug.output(3,"Modals: No context provided", modal);
        return false;
    }
    // Basket specific code, having to do this as the basket mechanism is not built on axis-lookups.js but has it's own set of listeners.
    const basketForm = context.parents('form' + expressSelectors()['basket']['form']);
    // Get accept button context.
    let acceptButton = modal.find('[' + expressSelectors()['modals']['accept-button'] + ']');
    // Fallback to way.
    if (!acceptButton.length) {
        acceptButton = modal.find('.prompt-proceed-button');
    }
    if (!acceptButton.length) {
        AXISDebug.output(3,"Modals: Failed to find accept button in modal", modal);
        return false;
    }
    // Close element.
    const closeButton = modal.find('.close-button');
    // Proceed / accept listener.
    acceptButton.on('click', function(event) {
        event.preventDefault();
        // Close modal.
        if (!modalClose()) {
            AXISDebug.output(3,"Modals: A modal failed to close after callback.");
        }
        // Trigger event.
        acceptButton.trigger('modal-accepted', modal);
        // Remove listener.
        acceptButton.off('click');
        // If iframe modal attached then fire that modal.
        if (context.data('modal-iframe')) {
            modalConfirm(context, modal);
        } else if (context.data('ajax') != undefined || basketForm.length) {
            // If the original button is a lookup then trigger toggle that code path.
            modalConfirm(context, modal);
        } else {
            context.parents('form').trigger('submit');
        }
    });

    // Return button context.
    let buttonContext = new Object();
    if (acceptButton.length) {
        buttonContext['accept-button'] = acceptButton;
    }
    if (closeButton.length) {
        buttonContext['close-button'] = closeButton;
    }
    return buttonContext;
}

function modalAjaxCallback(modal, customConfig = {}, instanceId) {
    return new Promise((resolve, reject) => {
        // Custom config for callback mechanism due to the complexity on putting together url and custom value pair.
        // let customConfig = {};
        // Get trigger button context.
        let button = getModalTriggerButtonContext(instanceId);

        let customValue = "";
        // Check trigger for name + value pair.
        if (button) {
            customValue = AXISAjax.getCustomNameValuePair(button);
            // Add customValue to custom config.
            if (customValue) {
                customConfig['custom-name-pair'] = customValue;
            }
        }
        // Callback location.
        let url = (!customConfig.hasOwnProperty('url') ? modal.data('ajax') : customConfig['url']);
        if (!url) {
            // Fallback to button.
            if (button.length) {
                // I know its inconsistant but buttons/anchors with data-ajax is already in use for lookups so this is to avoid a naming confliction.
                url = button.attr(expressSelectors()['ajax']['url']);
            } 
            // If still no luck then exit.
            if (!url) {
                AXISDebug.output(3,"Modals: No url found");
                return false;
            }
        }
        // Callback data.
        let data = "";
        // COMMENTING OUT OPERATION AS THIS GET INCLUDED IN prepareCallback() IN AXIS-AJAX.JS.
        // Operation.
        //let operation = AXISAjax.getOperation(modal);
        // TODO: Maybe operation needs a fallback to context button?
        // if (operation) {
        //     data = operation + (data ? "&" + data : "");
        // }
        // No longer needed this is based into the obj directly further on up the function.
        // if (customValue) {
        //     customConfig['custom-name-pair'] = customValue;
        // }
        // Get data type.
        let dataType = AXISAjax.getDataType(modal);
        // Injection container.
        let container = modalAjaxContainer(modal);
        // Should we be including a form's data?
        let includeFormData = getIncludeFormData(instanceId);
        // If include form data then serialise form and add the data to the query string.
        if (includeFormData) {
            // Form context.
            let form = getModalButtonForm(instanceId);
            // Holds form data that gets serialised.
            let formData = "";
            if (form) {
                formData = form.serialize();
                // Check if url has query string.
                let hasQueryString = queryStringParamsExists(url);
                // Add data to url.
                url = (hasQueryString ? url + "&" + formData : url + "?" + formData);
            }
        }
        // Add url to custom config.
        customConfig['url'] = url;
        // Do callback.
        AXISAjax.callback(modal, customConfig).then((data) => {
            // Get xhr object.
            let xhr = (data.hasOwnProperty('xhr') ? data['xhr'] : undefined);
            // Get response.
            let response = data['data'];
            // Is this a JSON response?
            let isJson = AXISAjax.isResponseJSON(xhr);
            // If the response is JSON the use that to update the container(s).
            if (isJson) {
                AXISAjax.update(modal, response).then(() => {
                    // Trigger event when content is updated.
                    modal.trigger('modal-content-updated', modal);
                }).catch((error) => {
                  AXISDebug.output(3,error);
                });
            } else {
                // Update modal.
                container.html(response);
                // Trigger event when content is updated.
                modal.trigger('modal-content-updated', modal);
            }
            // Resolve promise.
            resolve(modal);
        }).catch((error) => {
            reject(error);
        });
    });
    
}

function modalConfirm(context, modal) {
    // Check if initialisation element is a button, this is required as this functionality was originally written in the context of always being a clickable element but was later modified to be programatically triggered.
    const isButton = (context.is('button') || context.is('a') ? true : false);

    let conditionContext = $(context.data('condition-context'));

    context.attr(expressSelectors()['modals']['confirmed'], true);
    if (isButton) {
        context.trigger('click');
    }
    conditionContext.on('change', function() {
        context.removeAttr(expressSelectors()['modals']['confirmed']);
        conditionContext.off('change');
        return false;
    });
    modal.trigger('modal-confirmed', context);
}

function modalOpen(context, config = new Object) {

    // If the modal is already active class then exit.
    if (context.hasClass('active')) {
        return true;
    }
    // Check queue behavior from config or modal attribute.
    let queueBehavior = config['queue-behavior'] || context.attr(expressSelectors()['modals']['queue-behaviour']) || queueBehaviours['immediate'];

    // Check if there are any other modal active.
    let activeModals = $('.modal-container.active');

    // Handle queue behavior when other modals are active.
    if (activeModals.length > 0 && queueBehavior === queueBehaviours['queued']) {
        // Add to queue instead of opening immediately.
        const queueEntry = queueModal(context, config, queueBehavior);
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "Modals: Modal added to queue instead of opening", { queueId: queueEntry['id'] });
        }
        return Promise.resolve({ queued: true, queueEntry: queueEntry });
    }

    let activeModalCount = 0;

    // Track whether this is a background modal.
    const isBackgroundModal = queueBehavior === queueBehaviours['background'];

    if (activeModals.length > 0) {
        activeModals.each(function(key, value) {
            // Adding 1 due to key's being zero based.
            activeModalCount = (key + 1);
            // For background modals, don't reassign z-index of existing modals.
            if (!isBackgroundModal) {
                // Add z-index to modal.
                $(value).css('z-index', activeModalCount);
                // Assign modal priority ( the lower the better ) these will be the order they close in.
                $(value).attr(expressSelectors()['modals']['priority'], activeModalCount);
            }
        });
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Modals: there are other active modals")
        }
    }
    // Focus element - don't focus if this is a background modal.
    let focusElement = (config.hasOwnProperty('focus-element') && !isBackgroundModal ? config['focus-element'] : undefined);
    // Add active class.
    context.addClass('active');
    // Mark as background modal if applicable.
    if (isBackgroundModal) {
        context.attr('data-background-modal', 'true');
    }
    // Update instances.
    let instanceId = context.attr(expressSelectors()['modals']['modal-id']);
    instances[instanceId]['is-active'] = true;
    instances[instanceId]['is-background'] = isBackgroundModal;
    // Assign priority to the modal in context.
    if (activeModals.length > 0) {
        if (isBackgroundModal) {
            // Background modal: assign lowest priority and z-index below all active modals.
            // Find the minimum z-index from tracked instances.
            let minZindex = Infinity;
            $.each(instances, function(id, instance) {
                if (instance['is-active'] && !instance['is-background']) {
                    let modal = $('[' + expressSelectors()['modals']['modal-id'] + '="' + id + '"]');
                    let z = parseInt(modal.css('z-index')) || 0;
                    if (z < minZindex) minZindex = z;
                }
            });
            // Fallback if no foreground modals found.
            if (minZindex === Infinity) minZindex = 10;
            // Set z-index below all existing modals.
            context.css('z-index', Math.max(minZindex - 10, 1));
            // Assign lowest priority (0) so it doesn't close before foreground modals.
            context.attr(expressSelectors()['modals']['priority'], 0);
            // Blur this background modal since it's behind.
            blurContent(context);
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "Modals: Background modal opened behind active modals", { zindex: context.css('z-index') });
            }
        } else {
            // Get current modal z-index.
            let zindex = context.css('z-index');
            // Fallback.
            if (!zindex) {
                zindex = 1;
            }
            if (typeof(zindex) != "number") {
                zindex = parseInt(zindex);
            }
            // We now increment.
            zindex = (zindex + 10);
            context.css('z-index', zindex)
            context.attr(expressSelectors()['modals']['priority'], (activeModalCount + 1));
            // Blur active modals.
            blurContent(activeModals);
        }
    } else {
        // First modal - assign priority 1.
        context.attr(expressSelectors()['modals']['priority'], 1);
        if (!isBlurContentActive()) {
            // Blur background content.
            blurContent();
            // Remove scroll bar from background content.
            bodyScrollLock();
        }
        // Check if modal has been previously blurred.
        if (isBlurContentActive(context)) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(3,"Modals: Modal has blur effect applied, attempting to removed.", context);
            }
            blurContent(context, false);
        }
    }

    // Trigger event.
    context.trigger('modal-opened', context);
    // Check if focus element is defined as there is a possibility there may not be a proceed or close button.
    if (focusElement) {
        focusElement.trigger('focus');
    }
    // Handles closing of the modal.
    expressModalClose(context);

    return Promise.resolve(context);
}

function expressModalClose(context) {
    // Close options.
    // Remove close functionality all together.
    let suppressClose = context.attr(expressSelectors()['modals']['close-suppress']);
    // Close on background click.
    let onClick = context.attr(expressSelectors()['modals']['close-on-click']);
    if (onClick) {
        onClick = (onClick == "true");
    }
    // Default to true.
    if (onClick == undefined) {
        onClick = true;
    }
    // Close on Escape key press.
    let onEscape = context.attr(expressSelectors()['modals']['close-on-escape']);
    // Default to true.
    if (onEscape == undefined) {
        onEscape = true;
    }

    // --- Close Functionality ---
    // Close on click.
    if (onClick) {
        context.on('click', '.modal-background', function() {
            if (suppressClose == undefined) {
                if (!modalClose()) {
                    AXISDebug.output(1,"Modals: Attempted to close modal from its background");
                }
            }  
        });
    }

    // Close with escape key.
    if (onEscape) {
        // Check if event has been created.
        let keyupEvents = $._data($(document).get(0), "events").keyup;
        let onEscapeExists = false;
        $.each(keyupEvents, function(key, value) {
            if (value['data'] == "modal-escape-close") {
                onEscapeExists = true;
            }
        });

        if (!onEscapeExists) {
            $(document).on('keyup', "", "modal-escape-close", function(event) {
                if (event.key == "Escape") {
                    if (suppressClose == undefined) {
                        if (!modalClose()) {
                            AXISDebug.output(3,"Modals: Attempted to close modal using the escape key");
                        } 
                    }
                }
            });
        }
    }
    context.on('click', '.close-button, .prompt-cancel-button, [data-prompt-close], [data-close]', function() {
        // Button context.
        let button = $(this);
        // If the cancel button requires a callback ( i.e a lookup ) to the server but the response require's no interaction from the user then force closing of the modal whilst carrying out the request.
        let forceClose = button.is(expressSelectors()['lookups']['initialise']);
        if (!modalClose(context, forceClose)) {
            AXISDebug.output(1,"Modals: Attempted to close the modal from a button ( i.e [data-close])");
        }
    });
}

function triggerConditions(context) {

    let conditionContext = $(context.data('condition-context'));

    if (conditionContext.length > 0) {
        // Options obj
        let options = {};
        options['min'] = context.data('condition-min');
        options['max'] = context.data('condition-max');
        options['pattern'] = context.data('conditional-pattern')

        // Conditional options.
        if (options['min'] && getInputValue(conditionContext) < options['min']) {
            return true;
        }
        if (options['max'] && getInputValue(conditionContext) > options['max']) {
            return true;
        }

        if (options['pattern']) {
            // Create regular expression.
            pattern = new RegExp(options['pattern']);
            // Run test.
            let match = pattern.test(conditionContext);
            if (match) {
                return true;
            }
        }
        // If non of the conditions are met then return false.
        return false;

        // TODO: add support for one or more?
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Modals: Triggering modal as no data-condition-context was found.");
        }
        return true;
    }
}


function unsavedFormPromptsInitialise() {
    // Get all instances.
    let element = $("[" + expressSelectors()['forms']['unsaved-changes'] + "]");
    // If there are any instances.
    if (element.length > 0) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Modules: Unsaved changes prompt found attempting to intialise");
        }
        // Loop through each instance.
        $(element).each(function() {
            // Grab context.
            let context = $(this);
            // Initialise.
            let init = unsavedFormPrompt(context);
        });
    }
    
}

var formInstances = {};
// If changes are detected on a form and the cancel button is hit a prompt will be displayed.
function unsavedFormPrompt(context) {
    // Get form id.
    let id = context.data('unsaved-changes');
    // Get form context.
    let form = $('#' + id);

    // Unsaved changes prompt button.
    //let prompt = context.find('.unsaved-changes-prompt');

    if (id) {
        // Check if group has been initialised.
        if (!formInstances.hasOwnProperty(id)) {
            formInstances[id] = {};
            formInstances[id]['form-id'] = id;
            formInstances[id]['form'] = form;
            formInstances[id]['button'] = context;
        }
        let data = form.serialize();
        formInstances[id]['original-data'] = data;
        return true;
    } else {
        AXISDebug.output(2,"Unsaved Form Changes: No id or name or prompt/config button provided, failed to initialise prompt");
        return false;
    }
}

function modalClose(context, forceClose = false) {
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Modals: Closing modal");
    }
    // Check if there are any other modal active.
    let activeModals = getActiveModals();
    // How many modals are active.
    let activeModalCount = activeModals.length;
    // If none then exit.
    if (!activeModalCount) {
        return false;
    }
    // If context doesn't exist and there are multiple modal's open then find the one with the highest priority.
    if (!context && activeModalCount > 1) {
        // Find the modal with the max priority.
        let priorities = [];
        activeModals.each(function(key, value) {
            // Create jQuery selector.
            let modal = $(value);
            // Get the priority value and push it into the array.
            priorities.push(modal.attr(expressSelectors()['modals']['priority']));
        });
        // Select the active modal that matches the max priority.
        context = $('.modal-container.active[' + expressSelectors()['modals']['priority'] + '=' +  Math.max(...priorities) + ']');
    } else if (!context) {
        // Fallback just find an active modal.
        context = $('.modal-container.active');
    }
    // Check if modal is locked.
    const isLocked = (context.attr(expressSelectors()['modals']['locked']) != undefined);
    if (isLocked && !forceClose) {
        if (AXISDebug.level() >= 2) {
            AXISDebug.output(2,"Modals: Cannot close modal as its locked", context);
        }
        return false;
    }
    // Check whether there is any element(s) in the modal that are calling back to the server.
    let blockElements = context.find('[' + expressSelectors()['ajax']['content-block-element'] + ']');
    // Set flag to signal if there is active callback(s) within the modal.
    let hasActiveCallback = false;
    // If UI block elements exist, sometimes we need force the closing action when the send data to an endpoint behind the scenes ( e.g the demo modal setting a session state ).
    if (blockElements.length && !forceClose) {
        // Loop through them.
        blockElements.each(function() {
            // Block element context.
            let blockElement = $(this);
            // Get callback Id.
            let callbackId = blockElement.attr(expressSelectors()['ajax']['content-block-element']);
            hasActiveCallback = AXISAjax.isCallbackActive(callbackId);
            if (hasActiveCallback) {
                return false;
            }
        });
    }
    // Prevent closing the modal is a callback is currently active.
    if (hasActiveCallback) {
        AXISDebug.output(1,"Modals: There is content in this modal that has not finished calling back to the server, you must wait.", context);
        return false;
    }

    context.removeClass('active');
    // Remove background modal attribute if it was set.
    context.removeAttr('data-background-modal');
    // Update instances.
    let instanceId = context.attr(expressSelectors()['modals']['modal-id']);
    if (context.length) {
        instances[instanceId]['is-active'] = false;
        instances[instanceId]['is-background'] = false;
    }
    // If this is the last modal active then remove body scroll lock and un-blur content.
    if (activeModalCount == 1) {
        // Enable background content.
        blurContent();
        // Enable scroll bar from background content.
        bodyScrollLock();
        // Remove key listeners.
        $(document).off('keyup');
        // As this is the last modal active check to see if any other modal(s) have the blur class assigned, if they do it needs to be removed otherwise the modal will be blurred the next time it is opened.
        let previouslyBlurredModals = $('.modal-container.blur');
        if (previouslyBlurredModals.length > 0) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Modals: There are modals that have blur effect still active when the modal itself is not active, this should be disabled.", previouslyBlurredModals);
            }
            blurContent(previouslyBlurredModals, false);
        }

    } else {
        // Check if there are background modals that need to be promoted using instances.
        let hasActiveForegroundModal = false;
        let backgroundModalIds = [];

        $.each(instances, function(id, instance) {
            if (instance['is-active']) {
                if (instance['is-background']) {
                    backgroundModalIds.push(id);
                } else {
                    hasActiveForegroundModal = true;
                }
            }
        });

        // If all remaining modals are background modals, promote one.
        if (!hasActiveForegroundModal && backgroundModalIds.length > 0) {
            // Get the first background modal to promote (they all have priority 0).
            let promotedId = backgroundModalIds[0];
            let modalToPromote = $('[' + expressSelectors()['modals']['modal-id'] + '="' + promotedId + '"]');

            if (modalToPromote.length) {
                // Promote this background modal to foreground.
                modalToPromote.removeAttr('data-background-modal');
                blurContent(modalToPromote, false);
                // Update z-index to proper level.
                modalToPromote.css('z-index', 10);
                // Update instance.
                instances[promotedId]['is-background'] = false;
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1, "Modals: Background modal promoted to foreground", modalToPromote);
                }
            }
        } else {
            // Only unblur foreground modals (not background ones).
            // Build selector for active foreground modals that are blurred.
            let blurredForegroundModals = $('.modal-container.active.blur').filter(function() {
                let id = $(this).attr(expressSelectors()['modals']['modal-id']);
                return id && instances[id] && !instances[id]['is-background'];
            });
            if (blurredForegroundModals.length) {
                blurContent(blurredForegroundModals, false);
            }
        }
    }

    // Remove Listeners.
    context.off('click');
    // Check if proceed button exits.
    let proceedButton = context.find('.prompt-proceed-button');
    // Remove click listener from proceed button.
    if (proceedButton) {
        proceedButton.off('click');
    }

    // Check if contains video.
    let video = context.find('[' + expressSelectors()['axis-video-player']['initialise'] + ']');
    if (video.length) {
        // Stop video.
        axisVideoPlayer.pausePlayer(video);
    }

    // Fire event.
    context.trigger('modal-closed', context);

    // Make sure modal is closed.
    if (!(context.hasClass('active'))) {
        // Process the queue if there are no more active modals.
        // Use setTimeout to ensure the close event fully completes before opening next modal.
        setTimeout(() => {
            processQueue();
        }, 100);
        return true;
    }
}

// Find all active modals.
function getActiveModals() {
    // Modals that are active.
    let modals = "";
    // Loop through instances.
    $.each(instances, function(key, value) {
        // Instance.
        let instance = this;
        // Is active?
        let active = instance['is-active'];
        if (active) {
            // Build selector for active modals.
            modals = modals + (modals.length ? `, [${expressSelectors()['modals']['modal-id']}=${key}]` : `[${expressSelectors()['modals']['modal-id']}=${key}]`);
        }
    });
    // Create jQuery obj.
    modals = $(modals);
    // Old way of doing this using a class.
    //let modals = $('[data-modal].active');
    return modals;
}

function formOriginalState(id) {
    return formInstances[id]['original-data'];
}

// Retrieves active state of specific modal.
function isModalActive(context) {
    if (!context) {
        AXISDebug.output(3,"Modals: You must provide modal context", context);
    }
    // Get instance id.
    let id = getInstanceId(context);
    if (!id) {
        AXISDebug.output(1,"Modals: Could not find instance, has the modal been initialised?", context);
        return false;
    }
    if (instances[id].hasOwnProperty('is-active')) {
        return instances[id]['is-active'];
    } else {
        return false;
    }

}

// Toggle modal lock.
function toggleModalLock(context) {
    // Does the modal already have a lock? 
    const isLocked = (context.attr(expressSelectors()['modals']['locked']) != undefined);
    const toggle = modalLock(context, !isLocked);
    return toggle;
}

// Lock modal so its not closable.
function modalLock(context, status) {
    if (!context.length) {
        AXISDebug.output(1,"Modals: Cannot lock modal due to no context provided", context);
        return {
            success: false
        }
    }
    if (status) {
        context.attr(expressSelectors()['modals']['locked'], '');
        context.addClass('modal-locked');
    } else {
        context.removeAttr(expressSelectors()['modals']['locked']);
        context.removeClass('modal-locked');
    }
    return {
        success: true,
        context: context,
        "is-modal-locked": status,
    }
}

var AXISModals = $.AXISModals = {
    initialiseAll: () => {
        let initaliseExpressModals = initialiseAll();
        unsavedFormPromptsInitialise();
    },
    initialise: (context) => {
        return initialise(context);
    },
    open: (context, customConfig = {}) => {
        // Get instance id.
        let id = getInstanceId(context);
        modalOpen(context, customConfig);
        // If this is a AJAX modal.
        if (context.attr('data-ajax') || customConfig.hasOwnProperty('url')) {
            // Do some ajax stuff.
            modalAjaxCallback(context, customConfig, id);
        } else if (customConfig.hasOwnProperty('modal-confirm')) {
            modalConfirmListeners(context, customConfig);
        }
        return context;
    },
    modalClose: (context) => {
        if (context) {
            if (typeof(modal) != 'object') {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Modals: Context is not an Object, attempting to restore context on the assumption that a modal Id has been passed in.", context);
                }
                context = $('[' + expressSelectors()['modals']['modal-context'] + '="' + context + '"]');
                if (!context.length) {
                    AXISDebug.output(3,"Modals: Could not find modal in DOM");
                    return false;
                }
            }
        }
        return modalClose(context);
    },
    activeModals: () => {
        return getActiveModals();
    },
    isModalActive: (context) => {
        return isModalActive(context);
    },
    formOriginalState: (id) => {
        return formOriginalState(id);
    },
    getInstances: () => {
        return instances;
    },
    getQueue: () => {
        return getQueue();
    },
    clearQueue: (id) => {
        return clearQueue(id);
    },
    toggleModalLock: (context, override) => {
        // If override defined then bypass toggle.
        if (override != undefined) {
            return modalLock(context, override);
        } else {
            return toggleModalLock(context);
        }
    }
}

export { AXISModals }